import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BaseList from '@material-ui/core/List';
import BaseListItem from '@material-ui/core/ListItem';
import BaseListItemText from '@material-ui/core/ListItemText';
import BaseListItemIcon from '@material-ui/core/ListItemIcon';
import CheckedListIcon from './CheckedListIcon';
import DottedListIcon from './DottedListIcon';

const useStyles = makeStyles({
  root: {
    padding: 0,
  },
  item: {
    padding: 6,
  },
  icon: {
    minWidth: 24,
    justifyContent: 'center',
  },
  primary: {
    margin: 0,
    fontFamily: 'Open Sans, sans-serif',
    fontSize: 13,
    letterSpacing: '-0.3px',
  },
});

export interface ListItem {
  title: string | React.ReactElement;
  id: string | number;
  icon?: 'checked' | 'dotted';
  iconColor?: string;
  styles?: React.CSSProperties;
}

interface Props {
  items: Array<ListItem>;
}

const List: React.FC<Props> = ({ items }) => {
  const classes = useStyles();

  return (
    <BaseList className={classes.root}>
      {items.map((item: ListItem) => (
        <BaseListItem key={item.id} className={classes.item}>
          <BaseListItemIcon className={classes.icon}>
            {!item.icon && <div />}
            {item.icon === 'dotted' && <DottedListIcon color={item.iconColor} />}
            {item.icon === 'checked' && <CheckedListIcon color={item.iconColor} />}
          </BaseListItemIcon>
          <BaseListItemText primary={item.title} disableTypography className={classes.primary} style={item.styles} />
        </BaseListItem>
      ))}
    </BaseList>
  );
};

export default List;
